import React from 'react';

const defaultPageMetaData = {
  title: 'The Stock Vault',
  description: 'The Stock Vault | Administrator Panel',
  keywords: 'The Stock Vault, administrator panel, admin home',
};

function PageMetaData({
  title,
  description = defaultPageMetaData.description,
  keywords = defaultPageMetaData.keywords,
}) {
  return (
    <>
      <title>
        {title ? `${title} | ${defaultPageMetaData.title}` : defaultPageMetaData.title}
      </title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </>
  );
}
export default PageMetaData;
